/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {ControlFunctionDTO} from '../model/ControlFunctionDTO';
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';

/**
* ControlFunctionService service.
* @module api/ControlFunctionServiceApi
* @version v0
*/
export class ControlFunctionServiceApi {

    /**
    * Constructs a new ControlFunctionServiceApi. 
    * @alias module:api/ControlFunctionServiceApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getAllControlFunctions operation.
     * @callback moduleapi/ControlFunctionServiceApi~getAllControlFunctionsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ControlFunctionDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get control function hierarchy
     * Request to get all the operational scopes associated to each control function.
     * @param {module:api/ControlFunctionServiceApi~getAllControlFunctionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllControlFunctions(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [ControlFunctionDTO];

      return this.apiClient.callApi(
        '/api/control-function', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}